// app.js — reveal-on-scroll + count-up motion, ported verbatim from the design mockup's
// inline <script> (preview/design-mockup-template.html), plus a re-init guard and a
// rescan() hook for Shopify theme-editor section re-renders.
if (!window.__tmgMotion) {
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('in');
      e.target.querySelectorAll('[data-count]').forEach(run);
      if(e.target.hasAttribute('data-count')) run(e.target);
      io.unobserve(e.target);
    });
  },{threshold:.25});
  document.querySelectorAll('.rv,.stats .stat,.specs').forEach(function(el){io.observe(el)});
  // catch-up: reveal anything at or above the fold even if IO missed it (hidden tab, fast jump)
  function catchup(){
    document.querySelectorAll('.rv:not(.in),.specs:not(.in)').forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < innerHeight * 0.92){
        el.classList.add('in');
        el.querySelectorAll('[data-count]').forEach(run);
        io.unobserve(el);
      }
    });
  }
  var tick = false;
  function onScroll(){ if(tick) return; tick = true; requestAnimationFrame(function(){ catchup(); tick = false; }); }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll, {passive:true});
  document.addEventListener('visibilitychange', catchup);
  catchup();
  /* Figures count up in the page's own language: 1,500 in English, 1 500 in French. */
  var numLocale = (document.documentElement.lang || 'en') + '-CA';
  function run(el){
    if(el.__done) return; el.__done = true;
    var target = +el.getAttribute('data-count');
    if(!isFinite(target)){ return; }
    if(reduced){ el.textContent = target.toLocaleString(numLocale); return; }
    var t0 = null, dur = 1100;
    function step(ts){
      if(!t0) t0 = ts;
      var p = Math.min((ts-t0)/dur, 1);
      p = 1 - Math.pow(1-p, 3);
      el.textContent = Math.round(target*p).toLocaleString(numLocale);
      if(p<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  // rescan: (re)observe reveal/count-up targets inserted after initial load — e.g. the
  // Shopify theme editor re-rendering a section — then run one catch-up pass for anything
  // that landed above the fold already.
  function rescan(){
    document.querySelectorAll('.rv:not(.in),.stats .stat:not(.in),.specs:not(.in)').forEach(function(el){
      io.observe(el);
    });
    catchup();
  }
  document.addEventListener('shopify:section:load', function(){ window.__tmgMotion.rescan(); });
  window.__tmgMotion = { rescan: rescan };
})();
}
